import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-back\"><defs><style type=\"text/css\"></style></defs><path d=\"M656.93837 238.1h-272V103.6c0-13.8-14.8-22.8-27-16.4L9.93837 269.1c-13.4 7-13.2 26.1 0.3 32.9l347.9 173.9c12.2 6.2 26.7-2.7 26.7-16.5V324.2H657.03837c155 0 281 118.6 281 264.4S812.03837 853 657.13837 853H97.43837c-23.8 0-43 19.2-43 43s19.2 43 43 43h559.7c202.4 0 366.9-157.1 366.9-350.5 0-193.1-164.7-350.4-367.1-350.4z m0 0\" p-id=\"7578\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/back.svg
// module id = RN8c
// module chunks = 3